import { render } from "./AdmissionOverview.vue?vue&type=template&id=6b9a4201"
import script from "./AdmissionOverview.vue?vue&type=script&lang=js"
export * from "./AdmissionOverview.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__